const makeObjectWithSelectAll = (node, selection) => {
  const { id, selected } = node
  const {
    total,
    count: prevCount,
    excluded: prevExcluded,
    selectable
  } = selection

  // With selectAll = true, included remains empty
  const result = {
    included: {}
  }

  // If the item is selected
  // The item is removed if is present in the excluded object, the count is incremented
  if (selected) {
    const { [id]: remove, ...excluded } = prevExcluded
    result.excluded = excluded

    // Initialize the counter on the first "select all", taking into account selectable rows
    if (prevCount === 0) {
      result.count = !selectable ? total : prevCount + 1
    }

    // Update the counter only if the element was previously excluded
    if (prevCount > 0 && remove) {
      result.count = prevCount + 1
    }

    // Do not update the counter if the row was already selected but not rendered (i.e. on page change)
    if (prevCount > 0 && !remove) {
      result.count = prevCount
    }
  } else {
    // The item is added to the excluded list, the count is decremented
    result.excluded = {
      ...prevExcluded,
      [id]: node
    }
    result.count = prevCount - 1
  }

  // When the count is zero, everything is not selected and the excluded is being emptied
  if (result.count === 0 && Object.keys(result.excluded).length > 0) {
    result.excluded = {}
    result.selectAll = false
  }

  return result
}

const makeObjectWithoutSelectAll = (node, selection) => {
  const { id, selected } = node
  const { included: prevIncluded, total } = selection

  // With selectAll = false, excluded remains empty
  const result = {
    excluded: {}
  }

  if (selected) {
    // When the item is selected it is added to the included list
    result.included = {
      ...prevIncluded,
      [id]: node
    }
  } else {
    // The element is removed from the included object
    const { [id]: remove, ...included } = prevIncluded
    result.included = included
  }

  // The count is incremented/decremented
  result.count = Object.values(result.included).length

  // When all items are selected one by one, convert the selection into a select all
  if (selected && result.count === total) {
    result.included = {}
    result.selectAll = true
  }

  return result
}

export const getUpdatedSelectionOnRowSelected = (selection, node) => {
  const { selectAll } = selection

  const newSelection = selectAll
    ? makeObjectWithSelectAll(node, selection)
    : makeObjectWithoutSelectAll(node, selection)

  return newSelection
}

export const getUpdatedSelectionOnDataUpdate = (selection, total) => {
  const { selectAll } = selection
  if(!selectAll){
    return {...selection, total}
  }else{
    return {...selection, total, count: total-Object.keys(selection.excluded).length}
  }
}
